module.exports = __webpack_public_path__ + "static/media/lokahlogo.83438430.png";